import names from "./conf/verticals"

export const system = {
   branch: 'prod-portal',
   api: 'https://api.portal-display.com',
}

export const conf = names